var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { AddRowComponent } from '../../../../component/addrow/addrow.component';
import { AddRowService } from '../../../../component/addrow/addrow.service';
import { ConstructionMaterial } from './construction-material.service';
var KtsConstructionMaterialListComponent = /** @class */ (function (_super) {
    __extends(KtsConstructionMaterialListComponent, _super);
    function KtsConstructionMaterialListComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.changeMaterial = new EventEmitter();
        _this.normalCols = [];
        _this.specialCols = [];
        _this.materials = [];
        _this.constMaterials = {};
        return _this;
    }
    KtsConstructionMaterialListComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    KtsConstructionMaterialListComponent.prototype.ngOnChanges = function (changes) {
        if (changes.component) {
            this.primaryKey = jsonpath.value(this.component, '$.params.primaryKey') || '';
        }
        if (changes.normalCols) {
            this.cols = $.extend(true, [], this.normalCols);
        }
        if (changes.constMaterials || changes.materials) {
            var materials = JSOG.parse(JSON.stringify(this.materials));
            for (var _i = 0, materials_1 = materials; _i < materials_1.length; _i++) {
                var material = materials_1[_i];
                var constMaterial = this.constMaterials[material.id] || new ConstructionMaterial();
                if (material.type === "special" /* special */) {
                    material.manufacturers = constMaterial.special_notes;
                    material.unit = constMaterial.special_unit;
                }
                material.quantity = constMaterial.quantity;
            }
            var data = {};
            data[this.cols[0].key] = materials;
            _super.prototype.onSubscribe.call(this, data);
        }
    };
    KtsConstructionMaterialListComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        this.cols = $.extend(true, [], this.normalCols);
        this.orgCols = $.extend(true, [], this.cols);
        _super.prototype.checkReadonly.call(this);
    };
    KtsConstructionMaterialListComponent.prototype.onEvent = function (e1, e2, index) {
        _super.prototype.onEvent.call(this, e1, e2, index);
    };
    KtsConstructionMaterialListComponent.prototype.setCompRec = function () {
        var items = JSOG.parse(JSON.stringify(this.items));
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var constMaterial = this.constMaterials[item.id];
            if (item.type === "special" /* special */) {
                constMaterial.special_notes = item.manufacturers;
                constMaterial.special_unit = item.unit;
            }
            constMaterial.quantity = item.quantity;
        }
        this.changeMaterial.emit(this.constMaterials);
    };
    KtsConstructionMaterialListComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-construction-material-list',
                    template: "<form id=\"{{ componentName }}\">\n  <div class=\"tableWrapper\">\n    <table class=\"tableWrapper_table\">\n      <thead>\n      <tr data-href=\"#\">\n        <th *ngFor=\"let col of cols[0].items\" scope=\"col\">\n          <a a class=\"-fixed\">{{ col.label }}</a>\n        </th>\n      </tr>\n      </thead>\n      <tbody>\n      <ng-template ngFor let-item [ngForOf]=\"dispItems\" let-index=\"index\">\n        <tr *ngIf=\"item.type === 'normal'\" data-href=\"#\">\n          <td *ngFor=\"let col of cols[0].items\">\n            <ng-template [ngIf]=\"col.readonly || (!col.readonly && !col.hidden)\" [ngIfElse]=\"elseBlock\">\n              <column [key]=\"'list'\" [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"{\n                key: col.key,\n                controlType: col.controlType,\n                dataType: col.dataType,\n                required: col.required,\n                readonly: item.$editable ? col.readonly : true,\n                hidden: col.hidden,\n                params: col.params,\n                items: col.items\n              }\" [val]=\"item\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeRow($event, index)\"></column>\n            </ng-template>\n            <ng-template #elseBlock>\n              <columngroup [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"col\" [val]=\"item\" (changeVal)=\"onChangeRow($event, index)\"></columngroup>\n            </ng-template>\n          </td>\n        </tr>\n        <tr *ngIf=\"item.type === 'special'\" data-href=\"#\">\n          <ng-container  *ngFor=\"let col of specialCols[0].items\">\n            <td [attr.colspan]=\"col.colspan > 1 ? col.colspan : 1\">\n              <ng-template [ngIf]=\"col.readonly || (!col.readonly && !col.hidden)\" [ngIfElse]=\"elseBlock\">\n                <column [key]=\"'list'\" [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"{\n                  key: col.key,\n                  controlType: col.controlType,\n                  dataType: col.dataType,\n                  required: col.required,\n                  readonly: item.$editable ? col.readonly : true,\n                  hidden: col.hidden,\n                  params: col.params,\n                  items: col.items\n                }\" [val]=\"item\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeRow($event, index)\"></column>\n              </ng-template>\n              <ng-template #elseBlock>\n                <columngroup [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"col\" [val]=\"item\" (changeVal)=\"onChangeRow($event, index)\"></columngroup>\n              </ng-template>\n            </td>\n          </ng-container>\n        </tr>\n      </ng-template>\n      </tbody>\n    </table>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsConstructionMaterialListComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: AddRowService }
    ]; };
    KtsConstructionMaterialListComponent.propDecorators = {
        changeMaterial: [{ type: Output }],
        normalCols: [{ type: Input }],
        specialCols: [{ type: Input }],
        materials: [{ type: Input }],
        constMaterials: [{ type: Input }]
    };
    return KtsConstructionMaterialListComponent;
}(AddRowComponent));
export { KtsConstructionMaterialListComponent };
//# sourceMappingURL=construction-material-list.component.js.map